import {
    INITIATE_IMPERSONATION_SUCCESS,
    INITIATE_IMPERSONATION_FAILURE,
    SET_BANNER,
    SET_ERROR,
    CHECK_IMPERSONATION_ACTIVE,
} from '../actions';

const initialState = {
    impersonationKey: '',
    statusCode: '',
    statusMessage: '',
    banner: false,
    impersonationError: false,

    impersonationFlag: false,
    isImpersonationActive: false,
};

const impersonationReducer = (state = initialState, action) => {
    switch (action.type) {
        case INITIATE_IMPERSONATION_SUCCESS:
            return {
                ...state,
                impersonationKey: action.data.impersonationKey,
                statusCode: action.data.statusCode,
                impersonationError: false,
                banner: true,
                impersonationFlag: true,
            };
        case INITIATE_IMPERSONATION_FAILURE:
            return {
                ...state,
                impersonationError: true,
            };

        case SET_BANNER:
            return {
                ...state,
                banner: action.payload,
                statusCode: '',
            };
        case SET_ERROR:
            return {
                ...state,
                impersonationError: false,
            };
        case CHECK_IMPERSONATION_ACTIVE:
            return {
                ...state,
                ...action.payload,
            };
        default: {
            return { ...state };
        }
    }
};

export default impersonationReducer;
